import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { environment } from '../../environments/environment';

/*
  Generated class for the SmartLockProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SmartLockProvider {
  constructor(public http: HttpClient, private storage:Storage) {
    console.log('Hello SmartLockProvider Provider');
  }
 
  URL = environment.ismUrl;

  getToken(){
    return this.storage.get("loginDetails");
  }

  getUrl(link: string, val: any):string {
    return `${this.URL}${link}?api-token=${val.api_token}&user-id=${val.id}`;
  }

  getSmartLocks(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/my/door`,val))
        .toPromise();
      }
    });
  }

  unlockSmartLock(data){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/my/opendoor`,val),data)
        .toPromise();
      }
    });
  }
  requestStatus(data){
    return this.getToken().then((val) => {
      var makeData = null;
      if(data){
        makeData= `&id=${data.id}&request_id=${data.request_id}`
      }
      if(val){
        return this.http.get<Response>(this.getUrl(`/my/requeststatus`,val)+ (makeData?makeData:''))
        .toPromise();
      }
    });
  }
  updateVehicleAccessStatus(data){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/my/enableaccess`,val),data)
        .toPromise();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/smart-lock/smart-lock.ts